import { render } from "./modal-add-schools-to-district.vue?vue&type=template&id=5049c406&scoped=true"
import script from "./modal-add-schools-to-district.vue?vue&type=script&lang=js"
export * from "./modal-add-schools-to-district.vue?vue&type=script&lang=js"

import "./modal-add-schools-to-district.vue?vue&type=style&index=0&id=5049c406&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5049c406"],['__file',"src/components/admin-dashboard/modals/modal-add-schools-to-district.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5049c406"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5049c406', __exports__)) {
    api.reload('5049c406', __exports__)
  }
  
  module.hot.accept("./modal-add-schools-to-district.vue?vue&type=template&id=5049c406&scoped=true", () => {
    api.rerender('5049c406', render)
  })

}


export default __exports__